import React from "react";
import PropTypes from "prop-types";
import LazyImage from "../../shared/lazy-image";
import Button from "../../shared/button";
import styles from "./styles.css";
import CarImage from "./images/warranty-car.png";

const ExtendedWarrantyCardRevamp = ({onClick}) => {
    return (
        <div styleName={"styles.outer"}>
            <p styleName={"styles.heading"}>CARS24 Platinum Cover™</p>
            <p styleName={"styles.subText"}>Protect your car against mechanical issues with up to 3 years of<br />extended warranty</p>
            <LazyImage  width="288" height="148"  src={CarImage} alt="car image" />
            <Button text="learn more" onClick={onClick}/>
        </div>
    );
};

ExtendedWarrantyCardRevamp.propTypes = {
    onClick: PropTypes.func
};

export default ExtendedWarrantyCardRevamp;
